export function sliderReviews() {
    $(document).ready(function($){
        $('#slider-reviews').slick({
            arrows: true,
            centerMode: true,
            infinite: false,
            centerPadding: '0px',
            variableWidth: true,
            slidesToShow: 2,
            prevArrow: '<div class="slick-prev" aria-label="Previous" type="button"><svg width="65" height="50" viewBox="0 0 65 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="14.5073" width="50.026" height="50" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.54369 20L7.05894 21.5022L4.60212 23.9377H34.5176V26.0621H4.60212L7.05894 28.4978L5.54369 30L0.499908 25L5.54369 20Z" fill="#3BBFAD"/> </svg></div>',
            nextArrow: '<div class="slick-next" aria-label="Next" type="button"><svg width="65" height="50" viewBox="0 0 65 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.548828 0H50.5749V50H0.548828V0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M59.5384 20L58.0231 21.5022L60.4799 23.9377H30.5645V26.0621H60.4799L58.0231 28.4978L59.5384 30L64.5822 25L59.5384 20Z" fill="#3BBFAD"/></svg></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 2,
                        variableWidth: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '35px',
                        variableWidth: false,
                        slidesToShow: 1
                    }
                }
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/slider-reviews.js